import React from 'react';
import './spinner.scss';
const Spinner = ({ fixed = true }) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center spinner__wrapper ${
        fixed ? 'spinner__fixed' : ''
      }`}
    >
      <div className='spinner-border text-primary' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
